import { render, staticRenderFns } from "./separator.vue?vue&type=template&id=84a4fe18&scoped=true&"
import script from "./separator.ts?vue&type=script&lang=ts&"
export * from "./separator.ts?vue&type=script&lang=ts&"
import style0 from "./separator.scss?vue&type=style&index=0&id=84a4fe18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a4fe18",
  null
  
)

export default component.exports